import { render, staticRenderFns } from "./DoYouHaveNewUpsell.vue?vue&type=template&id=567b40ae&"
import script from "./DoYouHaveNewUpsell.vue?vue&type=script&lang=js&"
export * from "./DoYouHaveNewUpsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports